import React from 'react';
import './WorkflowIllustration.css';

const WorkflowIllustration = () => {
  return (
    <div className="workflow-illustration">
      <div className="workflow-header">
        <h2 className="workflow-title">
          Effortless Records, Accurate Data Make Collection So Easy!!!
        </h2>
        <p className="workflow-subtitle">Every Data in your Fingertips</p>
      </div>

      <div className="workflow-characters">
        {/* Collection Agent */}
        <div className="character character-agent">
          <div className="character-icon agent-icon">
            <div className="icon-face">👨‍💼</div>
            <div className="icon-phone">📱</div>
          </div>
          <div className="character-bubble agent-bubble">
            <span>Collection Agent</span>
          </div>
          <div className="character-details">
            <div className="detail-item">
              <span className="detail-icon">✓</span>
              <span>Collect Payments</span>
            </div>
            <div className="detail-item">
              <span className="detail-icon">📊</span>
              <span>Track Records</span>
            </div>
          </div>
        </div>

        {/* Flow Arrow */}
        <div className="flow-arrow">
          <div className="arrow-line"></div>
          <div className="arrow-head"></div>
          <div className="flow-icon-wrapper">
            <div className="flow-icon document-icon">📝</div>
          </div>
        </div>

        {/* Customer */}
        <div className="character character-customer">
          <div className="character-icon customer-icon">
            <div className="icon-face">👩</div>
            <div className="icon-phone">📱</div>
          </div>
          <div className="character-bubble customer-bubble">
            <span>Customer</span>
          </div>
          <div className="character-details">
            <div className="detail-item">
              <span className="detail-icon">💳</span>
              <span>Pay Online</span>
            </div>
            <div className="detail-item">
              <span className="detail-icon">📞</span>
              <span>Raise Complaints</span>
            </div>
          </div>
        </div>

        {/* Flow Arrow to Admin */}
        <div className="flow-arrow flow-to-admin">
          <div className="arrow-line"></div>
          <div className="arrow-head"></div>
          <div className="flow-icon-wrapper">
            <div className="flow-icon floppy-icon">💾</div>
          </div>
        </div>

        {/* Admin */}
        <div className="character character-admin">
          <div className="character-icon admin-icon">
            <div className="icon-face">👨‍💻</div>
            <div className="icon-laptop">💻</div>
          </div>
          <div className="character-bubble admin-bubble">
            <span>Admin</span>
          </div>
          <div className="notifications">
            <div className="notification notification-payment">
              <div className="notification-icon">✈️</div>
              <div className="notification-text">
                Payment Collect By Ravi(Online)
              </div>
            </div>
            <div className="notification notification-received">
              <div className="notification-icon">📄</div>
              <div className="notification-text">Payment Received</div>
            </div>
            <div className="golden-bell">🔔</div>
          </div>
        </div>
      </div>

      {/* Features Grid */}
      <div className="workflow-features">
        <div className="feature-box">
          <div className="feature-icon">⚡</div>
          <h3>Real-time Updates</h3>
          <p>Instant notifications for all transactions</p>
        </div>
        <div className="feature-box">
          <div className="feature-icon">📊</div>
          <h3>Accurate Records</h3>
          <p>Every transaction tracked and verified</p>
        </div>
        <div className="feature-box">
          <div className="feature-icon">🔒</div>
          <h3>Secure Payments</h3>
          <p>Safe and encrypted payment processing</p>
        </div>
        <div className="feature-box">
          <div className="feature-icon">📱</div>
          <h3>Mobile Access</h3>
          <p>Manage everything from your fingertips</p>
        </div>
      </div>
    </div>
  );
};

export default WorkflowIllustration;

